module.exports = __webpack_public_path__ + "static/shuttleid-mobile-ticket-with-qr-code-6a0ef9fa67cfa01f22c1099d8cd104d3.jpg";